import React from 'react';
import { FragmentType, graphql, useFragment } from '@frontend/gql/social';
import { MetricRadialChart } from '../../metric-radial-chart';

const cpmRadialFragment = graphql(`
  fragment CpmRadial_MetaSumInsights on MetaSumInsights {
    totalCpm
  }
`);

type CpmRadialProps = {
  currentInterval: FragmentType<typeof cpmRadialFragment> | null | undefined;
  currentIntervalNotAspireSourced?: FragmentType<typeof cpmRadialFragment> | null | undefined;
  showNonAttributedData?: boolean;
  currency: string;
};

export const CpmRadial = ({
  currentInterval,
  currentIntervalNotAspireSourced,
  showNonAttributedData = false,
  currency,
}: CpmRadialProps) => {
  const currentIntervalData = useFragment(cpmRadialFragment, currentInterval);
  const currentIntervalNotAspireSourcedData = useFragment(cpmRadialFragment, currentIntervalNotAspireSourced);

  const aspireValue = currentIntervalData?.totalCpm ?? 0;
  const nonAspireValue = showNonAttributedData ? (currentIntervalNotAspireSourcedData?.totalCpm ?? 0) : 0;

  // Only show the chart if the toggle is enabled
  if (!showNonAttributedData) {
    return null;
  }

  return (
    <MetricRadialChart
      aspireValue={aspireValue}
      nonAspireValue={nonAspireValue}
      metricType="currency"
      metricName="CPM"
      currency={currency}
    />
  );
};
